import { gql } from '@apollo/client';
import {
  GetBrandCategoriesQuery,
  GetBrandCategoriesQueryVariables,
  GetCategoriesQuery,
  GetCategoriesQueryVariables,
} from '__generated__/queries-web';
import { useFetch } from '../../../utils/useFetch';

const BRAND_CATEGORY_FRAGMENT = gql`
  fragment BrandCategoryFragment on Category {
    id
    title
    level
    status
  }
`;

export const GET_BRAND_CATEGORIES = gql`
  query GetBrandCategories($where: CategoryFilterInput!) {
    categories(where: $where, first: 150) {
      ...BrandCategoryFragment
      children(first: 150, where: { status: Published }) {
        ...BrandCategoryFragment
        children(first: 150, where: { status: Published }) {
          ...BrandCategoryFragment
          children(first: 150, where: { status: Published }) {
            ...BrandCategoryFragment
          }
        }
      }
    }
  }
  ${BRAND_CATEGORY_FRAGMENT}
`;

export const GET_CATEGORIES = gql`
  query GetCategories($where: CategoryFilterInput!) {
    categories(first: 1000, where: $where, orderBy: title_ASC) {
      id
      title
      level
      parent {
        id
      }
    }
  }
`;

export const useGetCategories = () =>
  useFetch<GetCategoriesQuery, GetCategoriesQueryVariables>(GET_CATEGORIES);

export const useGetBrandCategories = () =>
  useFetch<GetBrandCategoriesQuery, GetBrandCategoriesQueryVariables>(
    GET_BRAND_CATEGORIES,
  );
